import { Controller } from "@hotwired/stimulus";

const MAX_ROWS = 30;

export default class ReasonAliasesAdminController extends Controller {
  static targets = ["list", "row"];
  static values = {
    ariaKey: String,
    placeholderText: String,
    ariaText: String,
    ariaRemove: String,
  };

  addRow() {
    if (this.rowTargets.length >= MAX_ROWS) return;

    const idx = this.rowTargets.length;
    const row = document.createElement("div");
    row.className = "flex items-center gap-3 px-5 py-2.5";
    row.dataset.reasonAliasesAdminTarget = "row";
    row.innerHTML = `
      <input type="text" name="reason_aliases[${idx}][alias]" value=""
             placeholder="r1" class="input input-bordered input-sm font-mono w-16 text-center shrink-0">
      <span class="text-base-content/40">→</span>
      <input type="text" name="reason_aliases[${idx}][text]" value=""
             class="input input-bordered input-sm flex-1">
      <button type="button" class="btn btn-ghost btn-xs btn-square text-error/60 hover:text-error"
              data-action="click->reason-aliases-admin#removeRow">
        <i class="fa-solid fa-xmark text-xs"></i>
      </button>
    `;
    const [aliasInput, textInput] = row.querySelectorAll("input");
    aliasInput.setAttribute("aria-label", this.ariaKeyValue);
    textInput.placeholder = this.placeholderTextValue;
    textInput.setAttribute("aria-label", this.ariaTextValue);
    row.querySelector("button").setAttribute("aria-label", this.ariaRemoveValue);
    this.listTarget.appendChild(row);
    aliasInput.focus();
    this.#reindex();
  }

  removeRow(event) {
    event.currentTarget.closest("[data-reason-aliases-admin-target='row']")?.remove();
    this.#reindex();
  }

  #reindex() {
    this.rowTargets.forEach((row, idx) => {
      row.querySelectorAll("input[name]").forEach((input) => {
        input.name = input.name.replace(/\[\d+\]/, `[${idx}]`);
      });
    });
  }
}
